<div class="sectionContainer paddedContent" style="margin: 10px">
  <h2>Upload something</h2>
</div>
